import humps from 'humps'
import { defineAction } from '_utils/redux'
import * as menuItemServices from '_services/menu-items'

export const GET_MENU_ITEMS = defineAction('GET_MENU_ITEMS')

export const getMenuItems = params => async (dispatch, getState) => {
  const data = await menuItemServices.getRoleMenuItems(getState().user.authToken)(
    humps.decamelizeKeys(params)
  )
  dispatch({
    type: GET_MENU_ITEMS.ACTION,
    payload: async () => data,
    meta: params,
  })
  return data
}
